<template>
  <div class="loading-wrapper" >
    <div class="loading-img" :style="`width: ${w}px;height: ${h}px;`"></div>
  </div>
</template>

<script>
export default {
  name: 'Loading',

  props: {
    w: {type: String},
    h: {type: String},
  }
}

</script>

<style scoped>
.loading-wrapper {
  width: 100vw;
  height: 100vh;
  background: #fff;
}

.loading-img {
  background-image: url('../assets/img/282.gif');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
